// src/pages/workflow/CargaDocumentos.jsx - CORREGIDO con estados reales
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardHeader,
  Button,
  Grid,
  Typography,
  Box,
  Divider,
  Paper,
  Container,
  Tooltip,
  IconButton,
  LinearProgress,
  Alert,
  AlertTitle,
  Chip,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction
} from '@mui/material';
import {
  CloudUpload as CloudUploadIcon,
  Dashboard as DashboardIcon,
  Refresh as RefreshIcon,
  Home as HomeIcon,
  Description as DocumentIcon,
  PendingActions as PendingIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Warning as WarningIcon,
  Upload as UploadIcon,
  Download as DownloadIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  Assignment as AssignmentIcon,
  Gavel as GavelIcon
} from '@mui/icons-material';
import { 
  obtenerDocumentosRequeridos,
  subirDocumento,
  radicarDocumento,
  obtenerEstadoInscripcion,
  limpiarError, 
  reemplazarDocumento
} from '../../redux/slices/workflowSlice';
import firebaseStorageService from '../../services/firebaseStorage';
import useStyles from '../../theme/useStyles';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
// import { Alert, AlertTitle } from '@mui/material';

const CargaDocumentos = () => {
  const { entidadId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();

  const {
    documentosRequeridos,
    estadoWorkflow,
    documentosCargando,
    loading,
    error
  } = useSelector(state => state.workflow);

  const [workflowNegocioId, setWorkflowNegocioId] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState('todos');
  const [modalSubida, setModalSubida] = useState({ 
    abierto: false, 
    documento: null,
    archivo: null,
    progreso: 0,
    subiendo: false,
    validacionError: '',
    esReemplazo: false // AGREGAR ESTA LÍNEA
  });

  useEffect(() => {
    if (entidadId) {
      obtenerWorkflowId();
    }
  }, [entidadId]);

  useEffect(() => {
    if (workflowNegocioId) {
      dispatch(obtenerDocumentosRequeridos(workflowNegocioId));
    }
  }, [workflowNegocioId, dispatch]);

  const obtenerWorkflowId = async () => {
    try {
      const resultado = await dispatch(obtenerEstadoInscripcion(entidadId));

      console.log('resultado payload obtenido en estado: ',resultado.payload);

      if (resultado.payload?.esExitoso && resultado.payload?.estado) {
        setWorkflowNegocioId(resultado.payload.estado.workflowNegocioId);
      } else {
        setWorkflowNegocioId(1); // Temporal para desarrollo
      }
    } catch (error) {
      console.error('Error obteniendo workflow ID:', error);
      setWorkflowNegocioId(1);
    }
  };

  const handleSubirDocumento = (documento) => {
    setModalSubida({ 
      abierto: true, 
      documento,
      archivo: null,
      progreso: 0,
      subiendo: false,
      validacionError: ''
    });
  };

  const handleSeleccionarArchivo = (event) => {
    const archivo = event.target.files[0];
    if (!archivo) return;

    const validacion = firebaseStorageService.validarArchivo(archivo, {
      tamanoMaximo: modalSubida.documento.tamanoMaximo || 100 * 1024 * 1024,
      extensionesPermitidas: modalSubida.documento.extensionesPermitidas || '.pdf'
    });

    if (!validacion.valido) {
      setModalSubida(prev => ({
        ...prev,
        validacionError: validacion.errores.join(', '),
        archivo: null
      }));
      return;
    }

    setModalSubida(prev => ({
      ...prev,
      archivo,
      validacionError: ''
    }));
  };

  // ACTUALIZAR función de subida para manejar reemplazos
  const handleDocumentoSubido = async () => {
    if (!modalSubida.archivo || !modalSubida.documento) return;

    setModalSubida(prev => ({ ...prev, subiendo: true, progreso: 0 }));

    try {
      // 1. Generar ruta única para el archivo
      const rutaArchivo = firebaseStorageService.generarRutaArchivo(
        entidadId,
        modalSubida.documento.tipoDocumentoId,
        modalSubida.archivo.name
      );

      // 2. Si es un reemplazo, eliminar archivo anterior de Firebase
      if (modalSubida.esReemplazo && modalSubida.documento.rutaArchivo) {
        try {
          await firebaseStorageService.eliminarArchivo(modalSubida.documento.rutaArchivo);
          console.log('Archivo anterior eliminado:', modalSubida.documento.rutaArchivo);
        } catch (error) {
          console.warn('No se pudo eliminar archivo anterior:', error);
        }
      }

      // 3. Subir nuevo archivo a Firebase Storage
      const resultadoSubida = await firebaseStorageService.subirArchivo(
        modalSubida.archivo,
        rutaArchivo,
        (progreso, estado) => {
          setModalSubida(prev => ({
            ...prev,
            progreso: Math.round(progreso)
          }));
        }
      );

      // 4. Determinar si es subida nueva o reemplazo
      const accion = modalSubida.esReemplazo ? 'reemplazar' : 'subir';
      
      const documentoData = {
        workflowNegocioId: workflowNegocioId,
        tipoDocumentoId: modalSubida.documento.tipoDocumentoId,
        nombreArchivo: resultadoSubida.name,
        rutaArchivo: resultadoSubida.fullPath,
        mimeType: resultadoSubida.contentType,
        tamanoBytes: resultadoSubida.size,
        usuarioSubida: null,
        urlDescarga: resultadoSubida.downloadURL,
        esReemplazo: modalSubida.esReemplazo,
        documentoRequeridoId: modalSubida.esReemplazo ? modalSubida.documento.id : null
      };

      // 5. Llamar API según el tipo de acción
      let resultado;
      if (modalSubida.esReemplazo) {
        console.log('Ejecutando reemplazarDocumento...');
        resultado = await dispatch(reemplazarDocumento(documentoData));
      } else {
        console.log('Ejecutando subirDocumento...');
        resultado = await dispatch(subirDocumento(documentoData));
      }
      
      if (resultado.payload?.esExitoso) {
        await dispatch(obtenerDocumentosRequeridos(workflowNegocioId));
        setModalSubida({ 
          abierto: false, 
          documento: null,
          archivo: null,
          progreso: 0,
          subiendo: false,
          validacionError: '',
          esReemplazo: false
        });
      } else {
        throw new Error(resultado.payload?.mensaje || 'Error al procesar documento');
      }

    } catch (error) {
      console.error('Error procesando documento:', error);
      setModalSubida(prev => ({
        ...prev,
        subiendo: false,
        progreso: 0,
        validacionError: error.message || 'Error procesando archivo'
      }));
    }
  };

  const handleRadicarDocumento = async (documento) => {
    try {
      console.log('Radicando documento ID:', documento.id);
      const resultado = await dispatch(radicarDocumento({
        documentoRequeridoId: documento.id
      }));
      
      if (resultado.payload?.esExitoso) {
        await dispatch(obtenerDocumentosRequeridos(workflowNegocioId));
      }
    } catch (error) {
      console.error('Error radicando documento:', error);
    }
  };

  const handleVerDocumento = async (documento) => {
    try {
      if (documento.urlDescarga) {
        window.open(documento.urlDescarga, '_blank');
      } else if (documento.rutaArchivo) {
        const url = await firebaseStorageService.obtenerUrlDescarga(documento.rutaArchivo);
        window.open(url, '_blank');
      } else {
        console.warn('No hay URL de descarga disponible');
      }
    } catch (error) {
      console.error('Error obteniendo URL de descarga:', error);
      alert('Error al abrir el documento');
    }
  };

  const handleDescargarDocumento = async (documento) => {
    try {
      let url = documento.urlDescarga;
      if (!url && documento.rutaArchivo) {
        url = await firebaseStorageService.obtenerUrlDescarga(documento.rutaArchivo);
      }
      
      if (url) {
        const link = document.createElement('a');
        link.href = url;
        link.download = documento.nombreArchivo || 'documento.pdf';
        link.click();
      }
    } catch (error) {
      console.error('Error descargando documento:', error);
      alert('Error al descargar el documento');
    }
  };

  // NUEVA FUNCIÓN: Cambiar documento subido (estado 8)
  const handleCambiarDocumento = (documento) => {
    setModalSubida({ 
      abierto: true, 
      documento,
      archivo: null,
      progreso: 0,
      subiendo: false,
      validacionError: '',
      esReemplazo: true // Flag para indicar que es un reemplazo
    });
  };

  // *** FUNCIONES AUXILIARES CORREGIDAS SEGÚN ESTADOS REALES ***
  const puedeSubir = (documento) => {
    // Estados 1 (PENDIENTE) o 7 (PENDIENTE_RECARGA)
    return documento.estadoDocumentoId === 1 || documento.estadoDocumentoId === 7;
  };

  const puedeRadicar = (documento) => {
    // Solo estado 8 (SUBIDO) y que tenga archivo
    return documento.estadoDocumentoId === 8 && documento.rutaArchivo;
  };

  const estaSubido = (documento) => {
    // Estado 8 = SUBIDO (pendiente de radicación)
    return documento.estadoDocumentoId === 8;
  };

  const estaRadicado = (documento) => {
    // Estado 2 = RADICADO (pendiente de revisión)
    return documento.estadoDocumentoId === 2;
  };

  const estaEnRevision = (documento) => {
    // Estado 3 = EN_REVISION
    return documento.estadoDocumentoId === 3;
  };

  const estaAprobado = (documento) => {
    // Estado 4 = APROBADO
    return documento.estadoDocumentoId === 4;
  };

  const estaRechazado = (documento) => {
    // Estados 5 (RECHAZADO) o 7 (PENDIENTE_RECARGA)
    return documento.estadoDocumentoId === 5 || documento.estadoDocumentoId === 7;
  };

  const requiereCorreccion = (documento) => {
    // Estado 6 = REQUIERE_CORRECCION
    return documento.estadoDocumentoId === 6;
  };

  // *** FILTROS CORREGIDOS ***
  const documentosFiltrados = documentosRequeridos.filter(doc => {
    switch (filtroEstado) {
      case 'pendientes':
        return doc.estadoDocumentoId === 1; // PENDIENTE
      case 'subidos':
        return estaSubido(doc); // Estado 8 = SUBIDO
      case 'radicados':
        return estaRadicado(doc); // Estado 2 = RADICADO
      case 'en_revision':
        return estaEnRevision(doc); // Estado 3 = EN_REVISION
      case 'aprobados':
        return estaAprobado(doc); // Estado 4 = APROBADO
      case 'rechazados':
        return doc.estadoDocumentoId === 5 || doc.estadoDocumentoId === 7; // RECHAZADO o PENDIENTE_RECARGA
      default:
        return true;
    }
  });

  // *** ESTADÍSTICAS CORREGIDAS ***
  const estadisticas = {
    total: documentosRequeridos.length,
    pendientes: documentosRequeridos.filter(d => d.estadoDocumentoId === 1).length,
    subidos: documentosRequeridos.filter(d => estaSubido(d)).length, // Estado 8
    radicados: documentosRequeridos.filter(d => estaRadicado(d)).length, // Estado 2
    enRevision: documentosRequeridos.filter(d => estaEnRevision(d)).length, // Estado 3
    aprobados: documentosRequeridos.filter(d => estaAprobado(d)).length, // Estado 4
    rechazados: documentosRequeridos.filter(d => d.estadoDocumentoId === 5 || d.estadoDocumentoId === 7).length // Estados 5, 7
  };

  const porcentajeCompletado = estadisticas.total > 0 
    ? Math.round(((estadisticas.radicados + estadisticas.enRevision + estadisticas.aprobados) / estadisticas.total) * 100)
    : 0;

  const getDocumentStatusIcon = (documento) => {
    switch (documento.estadoDocumentoId) {
      case 1: return <DocumentIcon color="disabled" />; // PENDIENTE
      case 8: return <UploadIcon color="info" />; // SUBIDO (NUEVO)
      case 2: return <AssignmentIcon color="primary" />; // RADICADO
      case 3: return <GavelIcon color="warning" />; // EN_REVISION
      case 4: return <CheckCircleIcon color="success" />; // APROBADO
      case 5: case 7: return <ErrorIcon color="error" />; // RECHAZADO
      case 6: return <WarningIcon color="warning" />; // REQUIERE_CORRECCION
      default: return <DocumentIcon color="disabled" />;
    }
  };

  const getDocumentStatusChip = (documento) => {
    switch (documento.estadoDocumentoId) {
      case 1: return <Chip label="Pendiente" color="default" size="small" />;
      case 8: return <Chip label="Subido" color="info" size="small" />; // NUEVO
      case 2: return <Chip label="Radicado" color="primary" size="small" />;
      case 3: return <Chip label="En Revisión" color="warning" size="small" />;
      case 4: return <Chip label="Aprobado" color="success" size="small" />;
      case 5: return <Chip label="Rechazado" color="error" size="small" />;
      case 6: return <Chip label="Requiere corrección" color="warning" size="small" />;
      case 7: return <Chip label="Requiere recarga" color="error" size="small" />;
      default: return <Chip label="Desconocido" color="default" size="small" />;
    }
  };

  // *** FILTROS ACTUALIZADOS ***
  const filtros = [
    { id: 'todos', label: 'Todos', count: estadisticas.total },
    { id: 'pendientes', label: 'Pendientes', count: estadisticas.pendientes },
    { id: 'subidos', label: 'Subidos', count: estadisticas.subidos },
    { id: 'radicados', label: 'Radicados', count: estadisticas.radicados },
    { id: 'en_revision', label: 'En Revisión', count: estadisticas.enRevision },
    { id: 'aprobados', label: 'Aprobados', count: estadisticas.aprobados },
    { id: 'rechazados', label: 'Rechazados', count: estadisticas.rechazados }
  ];

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      minHeight: '100vh',
      p: 2,
      boxSizing: 'border-box'
    }}>
      <Card className={classes.card}
        sx={{ 
          width: '100%',
          maxWidth: 1400,
          margin: 'auto',
          mt: 4,
          p: 2
        }}
      >
        <CardHeader 
          classes={{ title: classes.cardTitle }}
          avatar={
            <CloudUploadIcon style={{ fontSize: "large", color: "#494949" }} />
          }
          title="Gestión de Documentos" 
          subheader="Suba, radique y gestione todos los documentos requeridos para el proceso de inscripción"
          action={
            <Grid container spacing={1} alignItems="center" justifyContent="center">
              <Grid item>
                <Tooltip title="Actualizar" arrow classes={{ tooltip: classes.tooltip }}>
                  <IconButton
                    onClick={() => {
                      if (workflowNegocioId) {
                        dispatch(obtenerDocumentosRequeridos(workflowNegocioId));
                      }
                    }}
                    variant="contained"
                    color="primary"
                    size="small"
                    className={classes.button}
                  >
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title="Volver al Dashboard" arrow classes={{ tooltip: classes.tooltip }}>
                  <IconButton
                    onClick={() => navigate(`/inscripcion/${entidadId}`)}
                    variant="contained"
                    color="secondary"
                    size="small"
                    className={classes.button}
                  >
                    <DashboardIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title="Inicio" arrow classes={{ tooltip: classes.tooltip }}>
                  <IconButton
                    onClick={() => navigate('/')}
                    variant="contained"
                    color="secondary"
                    size="small"
                    className={classes.button}
                  >
                    <HomeIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          }
          sx={{ 
            '& .MuiCardHeader-title': { fontSize: '1.25rem' },
            pr: 6
          }}
        />
        
        <CardContent sx={{ '&:last-child': { pb: 2 } }}>
          {/* Alertas */}
          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => dispatch(limpiarError())}>
              <AlertTitle>Error</AlertTitle>
              {error}
            </Alert>
          )}

          {/* Información del proceso de 3 pasos CORREGIDA */}
          <Alert severity="info" sx={{ mb: 3 }}>
            <AlertTitle>Proceso de gestión de documentos (Estados reales)</AlertTitle>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Paso 1:</strong> Subir archivo → El documento queda en estado "Subido" (8)
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Paso 2:</strong> Radicar documento → El documento pasa a estado "Radicado" (2)
            </Typography>
            <Typography variant="body2">
              <strong>Paso 3:</strong> Revisión administrativa → El documento se aprueba (4) o rechaza (5/6/7)
            </Typography>
          </Alert>

          {/* Progreso General */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
              Progreso de Documentos
            </Typography>
            
            <Paper elevation={1} sx={{ p: 3, mb: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 'medium' }}>
                  Progreso General
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {estadisticas.radicados + estadisticas.enRevision + estadisticas.aprobados} de {estadisticas.total} procesados
                </Typography>
              </Box>
              
              <LinearProgress 
                variant="determinate" 
                value={porcentajeCompletado} 
                sx={{ height: 8, borderRadius: 5, mb: 3 }}
                color={porcentajeCompletado === 100 ? 'success' : 'primary'}
              />

              <Grid container spacing={2}>
                <Grid item xs={6} sm={2}>
                  <Paper elevation={0} sx={{ p: 2, textAlign: 'center', bgcolor: 'grey.50', border: '1px solid', borderColor: 'grey.200' }}>
                    <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'grey.600' }}>
                      {estadisticas.pendientes}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Pendientes
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={6} sm={2}>
                  <Paper elevation={0} sx={{ p: 2, textAlign: 'center', bgcolor: 'info.50', border: '1px solid', borderColor: 'info.200' }}>
                    <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'info.600' }}>
                      {estadisticas.subidos}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Subidos
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={6} sm={2}>
                  <Paper elevation={0} sx={{ p: 2, textAlign: 'center', bgcolor: 'primary.50', border: '1px solid', borderColor: 'primary.200' }}>
                    <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'primary.600' }}>
                      {estadisticas.radicados}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Radicados
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={6} sm={2}>
                  <Paper elevation={0} sx={{ p: 2, textAlign: 'center', bgcolor: 'warning.50', border: '1px solid', borderColor: 'warning.200' }}>
                    <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'warning.600' }}>
                      {estadisticas.enRevision}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      En Revisión
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={6} sm={2}>
                  <Paper elevation={0} sx={{ p: 2, textAlign: 'center', bgcolor: 'success.50', border: '1px solid', borderColor: 'success.200' }}>
                    <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'success.600' }}>
                      {estadisticas.aprobados}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Aprobados
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={6} sm={2}>
                  <Paper elevation={0} sx={{ p: 2, textAlign: 'center', bgcolor: 'error.50', border: '1px solid', borderColor: 'error.200' }}>
                    <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'error.600' }}>
                      {estadisticas.rechazados}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Rechazados
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Paper>
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* Filtros */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
              Filtrar Documentos
            </Typography>
            
            <Paper elevation={0} sx={{ p: 2, bgcolor: 'grey.50' }}>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {filtros.map((filtro) => (
                  <Chip
                    key={filtro.id}
                    label={`${filtro.label} (${filtro.count})`}
                    onClick={() => setFiltroEstado(filtro.id)}
                    color={filtroEstado === filtro.id ? 'primary' : 'default'}
                    variant={filtroEstado === filtro.id ? 'filled' : 'outlined'}
                    sx={{ cursor: 'pointer' }}
                  />
                ))}
              </Box>
            </Paper>
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* Lista de Documentos */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
              Documentos Requeridos
            </Typography>
            
            {loading.obtenerDocumentos ? (
              <Grid container spacing={2}>
                {[...Array(6)].map((_, index) => (
                  <Grid item xs={12} md={6} lg={4} key={index}>
                    <Paper elevation={1} sx={{ p: 3 }}>
                      <Box sx={{ animate: 'pulse' }}>
                        <Box sx={{ height: 16, bgcolor: 'grey.200', borderRadius: 1, mb: 2 }} />
                        <Box sx={{ height: 12, bgcolor: 'grey.200', borderRadius: 1, mb: 1 }} />
                        <Box sx={{ height: 12, bgcolor: 'grey.200', borderRadius: 1, mb: 2 }} />
                        <Box sx={{ height: 40, bgcolor: 'grey.200', borderRadius: 1 }} />
                      </Box>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            ) : documentosFiltrados.length === 0 ? (
              <Paper elevation={1} sx={{ p: 8, textAlign: 'center' }}>
                <DocumentIcon sx={{ fontSize: 80, color: 'grey.300', mb: 2 }} />
                <Typography variant="h6" sx={{ fontWeight: 'medium', mb: 1 }}>
                  No hay documentos para mostrar
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {filtroEstado === 'todos' 
                    ? 'No se encontraron documentos requeridos'
                    : `No hay documentos con estado "${filtroEstado}"`
                  }
                </Typography>
              </Paper>
            ) : (
              <Grid container spacing={2}>
                {documentosFiltrados.map((documento) => (
                  <Grid item xs={12} md={6} lg={4} key={documento.id}>
                    <Paper 
                      elevation={1} 
                      sx={{ 
                        p: 3, 
                        height: '100%', 
                        display: 'flex', 
                        flexDirection: 'column',
                        '&:hover': { elevation: 3, transform: 'translateY(-2px)' },
                        transition: 'all 0.2s ease-in-out'
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        {getDocumentStatusIcon(documento)}
                        <Typography variant="h6" sx={{ ml: 1, fontWeight: 'medium', flex: 1 }}>
                          {documento.nombreTipoDocumento || documento.tipoDocumento}
                        </Typography>
                      </Box>
                      
                      <Box sx={{ mb: 2 }}>
                        {getDocumentStatusChip(documento)}
                      </Box>
                      
                      {documento.descripcionTipoDocumento && (
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          {documento.descripcionTipoDocumento}
                        </Typography>
                      )}
                      
                      <Box sx={{ mt: 'auto', display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        {/* Botón SUBIR - solo si está pendiente (estado 1 o 7) */}
                        {puedeSubir(documento) && (
                          <Button
                            variant="contained"
                            size="small"
                            startIcon={<UploadIcon />}
                            onClick={() => handleSubirDocumento(documento)}
                            disabled={documentosCargando[documento.tipoDocumentoId]}
                            sx={{ flex: 1 }}
                          >
                            {documentosCargando[documento.tipoDocumentoId] ? 'Subiendo...' : 'Subir'}
                          </Button>
                        )}
                        
                        {/* NUEVO: Botón CAMBIAR - solo si está subido (estado 8) */}
                        {estaSubido(documento) && (
                          <Button
                            variant="outlined"
                            color="warning"
                            size="small"
                            startIcon={<SwapHorizIcon />}
                            onClick={() => handleCambiarDocumento(documento)}
                            disabled={documentosCargando[documento.tipoDocumentoId]}
                            sx={{ flex: 1 }}
                          >
                            Cambiar
                          </Button>
                        )}
                        
                        {/* Botón RADICAR - solo si está subido (estado 8) */}
                        {puedeRadicar(documento) && (
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<AssignmentIcon />}
                            onClick={() => handleRadicarDocumento(documento)}
                            disabled={loading.radicarDocumento}
                            sx={{ flex: 1 }}
                          >
                            {loading.radicarDocumento ? 'Radicando...' : 'Radicar'}
                          </Button>
                        )}
                        
                        {/* Información de estado para documentos procesados */}
                        {(estaRadicado(documento) || estaEnRevision(documento) || estaAprobado(documento)) && (
                          <Box sx={{ flex: 1, textAlign: 'center', py: 1 }}>
                            <Typography variant="body2" color="text.secondary">
                              {estaRadicado(documento) && "Pendiente de revisión"}
                              {estaEnRevision(documento) && "En proceso de revisión"}
                              {estaAprobado(documento) && "✓ Documento aprobado"}
                            </Typography>
                          </Box>
                        )}
                        
                        {/* Botón RESUBIR - solo si fue rechazado (estados 5, 6, 7) */}
                        {estaRechazado(documento) && (
                          <Button
                            variant="contained"
                            color="warning"
                            size="small"
                            startIcon={<UploadIcon />}
                            onClick={() => handleSubirDocumento(documento)}
                            disabled={documentosCargando[documento.tipoDocumentoId]}
                            sx={{ flex: 1 }}
                          >
                            Resubir
                          </Button>
                        )}
                        
                        {/* Botones ver/descargar - si tiene archivo */}
                        {(documento.rutaArchivo || documento.urlDescarga) && (
                          <>
                            <Tooltip title="Ver documento">
                              <IconButton 
                                size="small" 
                                color="primary"
                                onClick={() => handleVerDocumento(documento)}
                              >
                                <VisibilityIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Descargar">
                              <IconButton 
                                size="small" 
                                color="secondary"
                                onClick={() => handleDescargarDocumento(documento)}
                              >
                                <DownloadIcon />
                              </IconButton>
                            </Tooltip>
                          </>
                        )}
                      </Box>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>

          {/* Mensaje de finalización CORREGIDO */}
          {estadisticas.total > 0 && estadisticas.pendientes === 0 && estadisticas.subidos === 0 && (
            <Alert severity="success" sx={{ mb: 3 }}>
              <AlertTitle>¡Todos los documentos han sido radicados!</AlertTitle>
              Su solicitud ha avanzado en el proceso de inscripción. 
              Los documentos radicados serán revisados por el equipo administrativo.
              <Box sx={{ mt: 2 }}>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => navigate(`/inscripcion/${entidadId}`)}
                >
                  Volver al Dashboard
                </Button>
              </Box>
            </Alert>
          )}

          {/* Instrucciones ACTUALIZADAS */}
          <Alert severity="info" sx={{ mt: 3 }}>
            <AlertTitle>Instrucciones del proceso de 3 pasos (Estados reales)</AlertTitle>
            <List dense>
              <ListItem sx={{ pl: 0 }}>
                <ListItemText primary="• PASO 1 - SUBIR: El archivo se sube y queda en estado 'Subido' (8)" />
              </ListItem>
              <ListItem sx={{ pl: 0 }}>
                <ListItemText primary="• PASO 2 - RADICAR: El documento pasa de 'Subido' (8) a 'Radicado' (2)" />
              </ListItem>
              <ListItem sx={{ pl: 0 }}>
                <ListItemText primary="• PASO 3 - REVISIÓN: El admin cambia de 'Radicado' (2) a 'Aprobado' (4) o 'Rechazado' (5)" />
              </ListItem>
              <ListItem sx={{ pl: 0 }}>
                <ListItemText primary="• Los documentos rechazados pueden ser resubidos con las correcciones necesarias" />
              </ListItem>
            </List>
          </Alert>
        </CardContent>
      </Card>

      {/* Modal para subir documento */}
      <Dialog 
        open={modalSubida.abierto} 
        onClose={() => !modalSubida.subiendo && setModalSubida({ 
          abierto: false, 
          documento: null,
          archivo: null,
          progreso: 0,
          subiendo: false,
          validacionError: '',
          esReemplazo: false
        })}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {modalSubida.esReemplazo ? 'Cambiar Documento' : 'Subir Documento'}: {modalSubida.documento?.nombreTipoDocumento}
          {/* Subir Documento: {modalSubida.documento?.nombreTipoDocumento || modalSubida.documento?.tipoDocumento} */}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ p: 2 }}>
            {/* Mostrar advertencia si es reemplazo */}
            {modalSubida.esReemplazo && (
              <Alert severity="warning" sx={{ mb: 3 }}>
                <AlertTitle>⚠️ Cambiar Documento</AlertTitle>
                Está a punto de reemplazar el documento actual. El archivo anterior será eliminado permanentemente.
                Asegúrese de que el nuevo documento es correcto antes de continuar.
              </Alert>
            )}
            {/* Información del documento */}
            <Box sx={{ mb: 3, p: 2, bgcolor: 'blue.50', borderRadius: 1, border: '1px solid', borderColor: 'blue.200' }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, color: 'blue.800' }}>
                📋 Requisitos del documento
              </Typography>
              <Typography variant="body2" sx={{ color: 'blue.700', mb: 1 }}>
                • <strong>Extensiones permitidas:</strong> .pdf
              </Typography>
              <Typography variant="body2" sx={{ color: 'blue.700', mb: 1 }}>
                • <strong>Tamaño máximo:</strong> 100 MB
              </Typography>
              <Typography variant="body2" sx={{ color: 'blue.700', mb: 1 }}>
                • El documento debe estar completo y ser legible
              </Typography>
              <Typography variant="body2" sx={{ color: 'blue.700' }}>
                • Una vez subido (estado 8), deberá radicarlo (estado 2) en el siguiente paso
              </Typography>
            </Box>

            {/* Área de selección de archivo */}
            <Box sx={{ textAlign: 'center', mb: 3 }}>
              {!modalSubida.archivo ? (
                <Box>
                  <CloudUploadIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Seleccione el archivo a subir
                  </Typography>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<UploadIcon />}
                    disabled={modalSubida.subiendo}
                  >
                    Seleccionar Archivo
                    <input
                      type="file"
                      hidden
                      accept=".pdf"
                      onChange={handleSeleccionarArchivo}
                    />
                  </Button>
                </Box>
              ) : (
                <Box>
                  <DocumentIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
                  <Typography variant="body1" sx={{ mb: 1, fontWeight: 'medium' }}>
                    {modalSubida.archivo.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {firebaseStorageService.formatearTamaño(modalSubida.archivo.size)}
                  </Typography>
                  {!modalSubida.subiendo && (
                    <Button
                      variant="text"
                      size="small"
                      onClick={() => setModalSubida(prev => ({ ...prev, archivo: null }))}
                    >
                      Cambiar archivo
                    </Button>
                  )}
                </Box>
              )}
            </Box>

            {/* Error de validación */}
            {modalSubida.validacionError && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {modalSubida.validacionError}
              </Alert>
            )}

            {/* Progreso de subida */}
            {modalSubida.subiendo && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Subiendo archivo... {modalSubida.progreso}%
                </Typography>
                <LinearProgress 
                  variant="determinate" 
                  value={modalSubida.progreso} 
                  sx={{ height: 8, borderRadius: 4 }}
                />
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          {/* <Button 
            onClick={() => setModalSubida({ 
              abierto: false, 
              documento: null,
              archivo: null,
              progreso: 0,
              subiendo: false,
              validacionError: ''
            })}
            disabled={modalSubida.subiendo}
          >
            Cancelar
          </Button>
          <Button 
            variant="contained" 
            disabled={!modalSubida.archivo || modalSubida.subiendo || modalSubida.validacionError}
            onClick={handleDocumentoSubido}
            startIcon={modalSubida.subiendo ? <CircularProgress size={20} /> : <UploadIcon />}
          >
            {modalSubida.subiendo ? 'Subiendo...' : 'Subir Documento (Estado 8)'}
          </Button> */}
            <Button onClick={() => setModalSubida(prev => ({ ...prev, abierto: false }))}>
              Cancelar
            </Button>
            <Button 
              onClick={handleDocumentoSubido}
              variant="contained"
              disabled={!modalSubida.archivo || modalSubida.subiendo}
            >
              {modalSubida.subiendo ? 
                `${modalSubida.esReemplazo ? 'Cambiando' : 'Subiendo'}...` : 
                (modalSubida.esReemplazo ? 'Cambiar Documento' : 'Subir Documento')
              }
            </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CargaDocumentos;